/* eslint no-param-reassign: "off" */
import { compose, combineReducers } from 'redux';

import store from './store';
import routingReducer, { refreshCurrentPath } from './ducks/routing';
import sessionReducer, { refreshLoggedIn } from './ducks/session';

// Globally available redux selectors
const injectAsyncReducers = (asyncReducers) => {
  store.reducers = { ...store.reducers, ...asyncReducers };

  store.replaceReducer(combineReducers(store.reducers));
};

const addActionDispatchers = (namespace, actions) => {
  Object.entries(actions).forEach(([key, value]) => {
    store.actionDispatchers[namespace] = store.actionDispatchers[namespace] || {};
    store.actionDispatchers[namespace][key] = compose(store.dispatch, value);
  });
};

store.reducers = {};

store.actionDispatchers = {};

window.reduxActionDispatchers = store.actionDispatchers;

window.reduxState = {
  store,
  addReducers: injectAsyncReducers,
  addActionDispatchers,
};

window.reduxState.addReducers({
  routing: routingReducer,
  session: sessionReducer,
});

window.reduxState.addActionDispatchers('routing', { refreshCurrentPath });
window.reduxState.addActionDispatchers('session', { refreshLoggedIn });
